import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import PauseIcon from '@mui/icons-material/Pause';
import StopIcon from '@mui/icons-material/Stop';
import LockIcon from '@mui/icons-material/Lock';

export const InterruptSectionContainer = styled(Box)({
  marginTop: 24,
  marginBottom: 8,
});

export const InterruptMenuItemRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
});

export const InterruptMenuItemTitle = styled(Typography)({
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: 1.3,
  color: 'var(--am-text-primary)',
}) as typeof Typography;

export const InterruptMenuItemDescription = styled(Typography)({
  fontSize: '12px',
  color: 'var(--am-text-secondary)',
  lineHeight: 1.3,
}) as typeof Typography;

export const InterruptMenuPauseIcon = styled(PauseIcon)({
  fontSize: 16,
  color: 'var(--am-text-secondary)',
});

export const InterruptMenuStopIcon = styled(StopIcon)({
  fontSize: 16,
  color: 'var(--am-text-secondary)',
});

export const InterruptMenuLockIcon = styled(LockIcon)({
  fontSize: 16,
  color: 'var(--am-text-secondary)',
});

export const BridgeGapsBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  marginTop: 12,
  padding: 16,
  borderRadius: 8,
  border: '1px solid var(--am-border)',
  backgroundColor: 'var(--am-surface)',
});

export const BridgeGapsTitle = styled(Typography)({
  fontWeight: 700,
  fontSize: '14px',
  lineHeight: 1.3,
  color: 'var(--am-text-primary)',
}) as typeof Typography;

export const BridgeGapsDescription = styled(Typography)({
  fontSize: '13px',
  color: 'var(--am-text-secondary)',
  lineHeight: 1.3,
}) as typeof Typography;
